import { GlobalMessageTypes } from './GlobalMessageTypes.enum';
export class GlobalMessage {
    constructor(type, message, title = null) {
        this._type = type;
        this._message = message;
        this._title = title;
        this.validate();
    }
    get type() {
        return this._type;
    }
    get message() {
        return this._message;
    }
    get title() {
        return this._title;
    }
    validate() {
        const types = [GlobalMessageTypes.CONFIRM, GlobalMessageTypes.ERROR, GlobalMessageTypes.INFO];
        if (types.indexOf(this._type) === -1) {
            throw new Error('Not a valid type Message Type: ' + this._type);
        }
        if (this._message.length === 0) {
            throw new Error('Message is not set. Add a message please!');
        }
        return true;
    }
}
